/**
 * Real time's "Repricing engine" mark (CU-869fmm943, Curro's decision on
 * Duda 1): a search the engine launched says which pass it belongs to and
 * links back to it in Executions. Only engine searches get it; every other
 * search — and every user without DS Repricing — sees Real time as before.
 *
 * Decision A (Curro): the pass is asked for only when the user has
 * `ds_repricing`; without it no request is made at all.
 */
import { fmtSlot } from '../../../DsRepricing/Executions/@services/slot.js'

export function shouldAsk(idSearch, featuresV2) {
	return Boolean(idSearch && featuresV2 && featuresV2.ds_repricing)
}

export function launchedLine(pass) {
	return pass ? `Launched by the pass of ${fmtSlot(pass.slot)}` : null
}

export function passHref(executionsPath, pass) {
	return `${executionsPath}?execution_id=${encodeURIComponent(pass.execution_id)}`
}
